export default "__VITE_ASSET__9abd0c42__"